import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    employeeSubtitle:
      'Once your card request has been reviewed, find and manage your cards right here.',
    subtitle: 'This is where you will find all the cards of the company',
    title: 'No card',
  },
  fr: {
    employeeSubtitle:
      'Une fois votre demande de carte acceptée par le titulaire du compte, retrouvez et gérez vos cartes juste ici.',
    subtitle:
      'C’est ici que vous retrouverez l’ensemble des cartes de la société',
    title: 'Aucune carte',
  },
});

export default locales;
